"use strict";
// (C) 2019-2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_DATE_FORMAT = exports.platformDateFormat = void 0;
// date format used on server
exports.platformDateFormat = "YYYY-MM-DD";
// default date format used on client
exports.DEFAULT_DATE_FORMAT = "MM/dd/yyyy";
//# sourceMappingURL=Platform.js.map